function escapeRegExp(str) {
    return String(str).replace(/[\\^$.*+?()[\]{}|/=<>!&:-]/g, (m) => `\\${m}`);
}

export function transformToWafRuleData(analyzedResult, wafRuleDraft = {}) {
    // Header 欄位的對應轉換規則（來源欄位 → 實際 header 名稱）
    const headerMap = {
        server_name: "host",
        referer: "referer",
        "user-agent": "user-agent",
        "accept-encoding": "accept-encoding",
        "accept-language": "accept-language",
    };

    // 欄位對應與轉換邏輯清單
    const fieldMappings = [
        {
            // 將 IP 陣列轉成 "x.x.x.x/32\n..." 的格式
            targetKey: "wafIp",
            sourceKey: "cus_realy_addr",
            transform: (values) => {
                if (!Array.isArray(values)) return "";
                return values
                    .filter((v) => v !== "EMPTY" && v !== "NOTEXIST")
                    .map((ip) => ip + "/32")
                    .join("\n");
            },
        },
        {
            // 將 URI 陣列以換行分隔，若無資料則預設為 ""
            targetKey: "wafUri",
            sourceKey: null, // 改為 null，因為會用到多個欄位
            transform: () => {
                const { raw_uri: uris = [], raw_args: args = [] } = analyzedResult || {};

                const clean = (analyzedResult) => analyzedResult.filter((e) => e !== "EMPTY" && e !== "NOTEXIST");

                const filteredUris = clean(uris);
                const filteredArgs = clean(args);

                // 先把 args 當字串全跳脫
                const escapedArgs = filteredArgs.map((arg) => escapeRegExp(arg));

                // args：字串本身跳脫，但 .* 與 | 是 regex 運算子，不跳脫
                const argsRegex = escapedArgs.map((arg) => `.*${arg}`).join("|");

                return filteredUris
                    .map((uri) => {
                        const escapedUri = escapeRegExp(uri);
                        // 沒 args 就只回 uri；有 args 就組成 uri\?( ...OR... )
                        return escapedArgs.length === 0 ? escapedUri : `${escapedUri}\\?(${argsRegex})`;
                    })
                    .join("\n");
            },
        },
        {
            // 將 ISP 陣列以換行分隔，若無資料則為空字串
            targetKey: "wafIsp",
            sourceKey: "isp",
            transform: (values) => (Array.isArray(values) && values.length > 0 ? values.join("\n") : ""),
        },
        {
            // 國家陣列，若不是陣列則預設為空陣列
            targetKey: "wafCountry",
            sourceKey: "country",
            transform: (values) => {
                if (!Array.isArray(values)) return [];
                return values.filter((v) => v !== "EMPTY" && v !== "NOTEXIST");
            },
        },
        {
            // proxyType 陣列
            targetKey: "wafProxyType",
            sourceKey: "proxyType",
            transform: (values) =>
                Array.isArray(values) ? values.filter((v) => v != "NULL").map((v) => String(v).toLowerCase()) : [],
        },
        {
            // HTTP method 陣列
            targetKey: "wafHttpMethod",
            sourceKey: "request_method",
            transform: (values) => (Array.isArray(values) ? values.map((v) => String(v).toLowerCase()) : []),
        },
        {
            // 將存在的 header 組成為 "key: value" 的字串，用 \n 分隔
            // 特殊計算欄位：需同時掃描多個欄位 (headerMap) 判斷 NOTEXIST / EMPTY
            targetKey: "wafHeaders",
            sourceKey: null,
            transform: () => {
                const headersExist = [];
                for (const key in headerMap) {
                    const headerName = headerMap[key];
                    const values = analyzedResult[key];
                    if (!Array.isArray(values)) continue;

                    if (values.includes("NOTEXIST")) continue;

                    for (const val of values) {
                        if (val === "EMPTY") {
                            headersExist.push(`${headerName}:^$`);
                        } else {
                            headersExist.push(`${headerName}:${val}`);
                        }
                    }
                }
                return headersExist.join("\n");
            },
        },
        {
            // 收集所有 "NOTEXIST" 的 header 名稱
            // 特殊計算欄位：從 headerMap 對應欄位中尋找 NOTEXIST
            targetKey: "wafHeadersNotExist",
            sourceKey: null,
            transform: () => {
                const headersNotExist = [];
                for (const key in headerMap) {
                    const headerName = headerMap[key];
                    const values = analyzedResult[key];
                    if (Array.isArray(values) && values.includes("NOTEXIST")) {
                        headersNotExist.push(headerName);
                    }
                }
                return headersNotExist.join("\n");
            },
        },
        {
            targetKey: "groupName",
            sourceKey: "group",
            transform: (values) => (Array.isArray(values) && values.length > 0 ? values[0] : ""),
        },
        {
            // JA3 指紋雜湊
            targetKey: "wafJa3Hashes",
            sourceKey: "ssl_ja3_hash",
            transform: (values) => {
                if (!Array.isArray(values)) return [];
                return values.filter((v) => v !== "EMPTY");
            },
        },
    ];

    // 執行欄位補全或覆蓋邏輯
    for (const field of fieldMappings) {
        // 根據 sourceKey 取出來源欄位的值（若無 sourceKey 表示是特殊計算欄位）
        const srcValue = field.sourceKey ? analyzedResult[field.sourceKey] : undefined;

        // 執行轉換並寫入 wafRuleDraft
        wafRuleDraft[field.targetKey] = field.transform(srcValue);
    }
    return wafRuleDraft;
}



// WEBPACK FOOTER //
// ./src/libs/transformToWafRuleData.js